// extracted by mini-css-extract-plugin
export default {"fullName":"namePlusThumbnail_fullName__dJvQA","image":"namePlusThumbnail_image__7dnJT","label":"namePlusThumbnail_label__bcmIg"};